exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-status-label[data-v-b615497c]{\n  padding: 10px 0px;\n  color: var(--wf-secondary);\n  font-weight: 600;\n  cursor: pointer;\n}\n", ""]);

// exports
